import { ChangeDetectionStrategy, Component, ElementRef, inject, input, model, output, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsBoxModule, DsButtonModule, DsCheckboxModule, DsLabelModule, DsModalModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { PaginationProvider } from '../../../utils/pagination/pagination.provider';
import { modalOpenOrClosing } from '../../../utils/signal/modalOpenOrClosing';
import { AddVehicleModalContainer } from './add-vehicle-modal.container';
import { AddVehicle } from './vehicles.view-model';

@Component({
  selector: 'cdf-add-vehicle-modal-wrapper',
  imports: [
    DsButtonModule,
    DsCheckboxModule,
    DsLabelModule,
    FormsModule,
    DsBoxModule,
    DsModalModule,
    AddVehicleModalContainer,
  ],
  providers: [PaginationProvider],
  template: `
    <ds-modal [ds-modal-trigger-for]="modal" [(isModalOpen)]="open" #modal size="lg">
      <ds-box-header>
        {{ i18n('vehicles.addVehicleModal.heading') }}
        <span class="text-regular text-neutral d-inline">({{ paginationProvider.stepString() }})</span>
      </ds-box-header>
      <ds-box-content>
        @if (openOrClosing()) {
          <cdf-add-vehicle-modal
            [loading]="loading()"
            [accountNumber]="accountNumber()"
            (closeModal)="open.set(false)"
            (addVehicle)="confirmAdd.emit($event)"
          />
        }
      </ds-box-content>
    </ds-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddVehicleModalWrapper {
  protected readonly i18n = useI18n();
  protected readonly paginationProvider = inject(PaginationProvider);

  readonly loading = input(false);
  readonly open = model(true);
  readonly accountNumber = input.required<string>();

  private readonly modal = viewChild.required('modal', { read: ElementRef });
  protected readonly openOrClosing = modalOpenOrClosing(this.open, this.modal);

  readonly confirmAdd = output<AddVehicle>();
}
